import React, { useState } from "react";
import { Box, Heading, Stack } from "@chakra-ui/react";
import InputBox from "./components/Input";
import DropDown from "./components/Dropdown";
import Results from "./components/Results";
import html2canvas from "html2canvas";

function App() {
  const concentrationOptions = [
    { id: 1, name: "100 mg/ml", value: 100 },
    { id: 2, name: "200 mg/ml", value: 200 },
    { id: 3, name: "250 mg/ml", value: 250 },
  ];
  const frequencyOptions = [
    { id: 1, name: "Once Per Week", value: 1 },
    { id: 2, name: "Twice Per Week", value: 2 },
    { id: 3, name: "Three Times Per Week", value: 3 },
    { id: 4, name: "Every Other Day", value: 3.5 },
    { id: 5, name: "Daily", value: 7 },
  ];

  // const [concentration, setConcentration] = useState(concentrationOptions)

  const [selectedConcentration, setSelectedConcentration] = useState(null);
  const [selectedFrequency, setSelectedFrequency] = useState(null);
  const [selectedWeeklyDose, setSelectedWeeklyDose] = useState(null);
  const [calculationTimeout, setCalculationTimeout] = useState(null);

  const handleConcentrationChange = (event) => {
    console.log(event.target.value);
    setSelectedConcentration(event.target.value);
  };

  const handleFrequencyChange = (event) => {
    console.log(event.target.value);
    setSelectedFrequency(event.target.value);
  };

  const handleWeeklyDose = (event) => {
    let inputWeeklyDose = event.target.value;
    clearTimeout(calculationTimeout);
    const numericValue = inputWeeklyDose.replace(/[^0-9]/g, "");

    const timeoutId = setTimeout(() => {
      setSelectedWeeklyDose(numericValue);
    }, 300); // Set a delay of 300 milliseconds before updating the selectedWeeklyDose

    setCalculationTimeout(timeoutId);
  };

  const handleKeyPress = (event) => {
    // Allow only numeric characters, Backspace, and arrow keys
    if (!/[0-9]|Backspace|ArrowLeft|ArrowRight/.test(event.key)) {
      event.preventDefault();
    }
  };

  const captureResultsAsImage = () => {
    const resultsContainer = document.getElementById("results"); // Replace with your results container's ID or selector

    if (resultsContainer) {
      html2canvas(resultsContainer).then((canvas) => {
        // Convert the canvas to a data URL and create a download link
        const dataURL = canvas.toDataURL("image/png");
        const downloadLink = document.createElement("a");
        downloadLink.href = dataURL;
        downloadLink.download = "results.png";
        downloadLink.click();
      });
    }
  };

  return (
    <Box textAlign="center" p={4} size="md">
      <Heading size="md"> Testosterone Dose Calculator</Heading>
      <Stack>
        <InputBox
          title={"Weekly Dose (mg)"}
          handler={handleWeeklyDose}
          inputValue={selectedWeeklyDose}
          handleKey={handleKeyPress}
        />
        <DropDown
          title={"Select Testosterone Vial Concentration"}
          values={concentrationOptions}
          selectedValue={selectedConcentration}
          handler={handleConcentrationChange}
        />
        <DropDown
          title={"Select Injection Frequency"}
          values={frequencyOptions}
          selectedValue={selectedFrequency}
          handler={handleFrequencyChange}
        />
      </Stack>
      {selectedWeeklyDose && selectedConcentration && selectedFrequency && (
        // calculateDose(selectedWeeklyDose, selectedFrequency, selectedConcentration)
        <Results
          max={30}
          weeklyAmt={selectedWeeklyDose}
          frequency={selectedFrequency}
          concentration={selectedConcentration}
          handleScreenshot={captureResultsAsImage}
        />
      )}
    </Box>
  );
}

export default App;
